import { ProductDetail } from '@/features/products/ProductDetail';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/products/$productId')({
  staticData: { nav: 'products' },
  component: ProductDetail,
});
